import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const blogs = [
  {
    id: 1,
    title: 'Why Insta Cafe is Famous in Nagercoil',
    excerpt: 'Discover what makes Insta Cafe the go-to spot for tea lovers and food enthusiasts in Nagercoil. From our secret recipes to our warm ambiance...',
    image: 'https://images.unsplash.com/photo-1521017432531-fbd92d768814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzcxMDY4NDc1fDA&ixlib=rb-4.1.0&q=85',
    date: 'Dec 15, 2024',
    category: 'Story'
  },
  {
    id: 2,
    title: 'Best Snacks to Try with Tea',
    excerpt: 'Explore the perfect pairings of our premium teas with delicious snacks. Learn which combinations create the ultimate tea-time experience...',
    image: 'https://images.unsplash.com/photo-1616103425322-91736a8724a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHx0ZWElMjBzaG9wfGVufDB8fHx8MTc3MTA2ODQ4M3ww&ixlib=rb-4.1.0&q=85',
    date: 'Dec 10, 2024',
    category: 'Food Guide'
  },
  {
    id: 3,
    title: 'Top 5 Mojitos Customers Love',
    excerpt: 'From classic virgin mojitos to exotic blue curacao, discover our most popular refreshing drinks that keep customers coming back for more...',
    image: 'https://images.unsplash.com/photo-1653542772393-71ffa417b1c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2ppdG98ZW58MHx8fHwxNzcxMDY4NTI5fDA&ixlib=rb-4.1.0&q=85',
    date: 'Dec 5, 2024',
    category: 'Drinks'
  }
];

export const BlogSection = () => {
  return (
    <section className="section-padding">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Latest Blogs
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
            Stay updated with our latest news and articles
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <article key={blog.id} className="cafe-card overflow-hidden">
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute top-4 left-4 bg-secondary text-foreground px-3 py-1 rounded-full text-xs font-semibold">
                  {blog.category}
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
                  <Calendar className="w-4 h-4" />
                  <span>{blog.date}</span>
                </div>
                <h3 className="text-xl font-display font-semibold text-foreground mb-3 leading-tight">
                  {blog.title}
                </h3>
                <p className="text-muted-foreground text-sm mb-4 leading-relaxed">
                  {blog.excerpt}
                </p>
                <Button variant="link" className="p-0 h-auto font-semibold text-primary">
                  Read More
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;